import Pagination from "react-js-pagination";

const Table = ({ data, activePage, handlePageChange }) => {
  return (
    <div className="activity-table shadow px-3 py-4 mt-4 mx-2 mb-5">
      <p className="hdng-para">
        Details of user activities on School Dashboard
      </p>
      <div className="table-data table-responsive">
        <table className="table table-inr mb-0">
          <thead>
            <tr className="border-0">
              <th className="border-bottom-0 text-center">Class</th>
              <th className="border-bottom-0 text-center">Section</th>
              <th className="border-bottom-0 text-center">Teacher name</th>
              <th className="border-bottom-0 text-center">Roles</th>
              <th className="border-bottom-0 text-center">
                Associated students
              </th>
              <th className="border-bottom-0 text-center border-end-0">
                Avg performances of students
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.map((item, index) => {
              return (
                <tr>
                  <td>{item?.className}</td>
                  <td>{item?.sectionName}</td>
                  <td>{item?.teacherName}</td>
                  <td>{item?.role}</td>
                  <td>{item?.associatedStudents}</td>
                  <td className="border-0">
                    {Math.ceil(item?.averagePerformanceOfStudents)}%
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {data?.pagination_info &&
        <div className="pagination-bar w-100 d-flex justify-content-between border-top-0">
          <p className="counting mb-0">{activePage} out of {data?.pagination_info?.total_pages}</p>
          <nav aria-label="Page navigation example">
            <Pagination
              activePage={activePage}
              itemsCountPerPage={data?.pagination_info?.page_size}
              totalItemsCount={data?.pagination_info?.total_elements}
              pageRangeDisplayed={5}
              innerClass="pagination mb-0 p-0"
              itemClass="page-item"
              linkClass="page-link"
              onChange={handlePageChange}
            />
          </nav>
        </div>
      }
    </div>
  );
};

export default Table;
